import * as styles from './errorMsg.module.css';

export const ErrorMsg = ({msg,errWrapperClassName=''}) => (<div className={ `${errWrapperClassName} ${styles[ 'error-msg' ]}` }>
    <div>{ msg }</div>
</div> )